/* eslint-disable */

import headerAfterLogin from '../headerAfterLogin/index';
import headerBeforeLogin from '../headerBeforeLogin/index';

export default {
  name: 'app_header',
  components: {
    'header-before-login': headerBeforeLogin,
    'header-after-login': headerAfterLogin
  },
  props: [],
  data() {
    return {
      isLoggedIn: false
    }
  },
  computed: {
    checkUserLogin() {
      return this.isLoggedIn = this.$store.getters.isAuthenticated
    }
  },
  mounted() {

  },
  methods: {

  },
  watch: {
    checkUserLogin() {
      return this.$store.getters.isAuthenticated
    }
  }
}